export const razorPayKey = process.env.REACT_APP_RAZORPAY_KEY;
